import React, { useContext, useEffect, useCallback } from "react"
import i18n from "i18n"
import { API, Auth } from "aws-amplify"
import { Grid } from "@mui/material"
import AuthContext from "context/auth/authContext"
import { LinkAsOutlinedButton } from "components/Feed/CustomStyles"
import { extractChargebeePortalSession } from "utils/functions"

const PricingPage = () => {
  const { user, createChargebeePortal, getCustomerInfo } =
    useContext(AuthContext)
  useEffect(() => {
    if (window.Pricify) {
      window.Pricify.openPricingPage({
        pricingPage: async () => {
          const CORE = "CORE"

          const headers = {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            "Access-Control-Allow-Origin": "*",
          }

          const body = {
            customer_id: user?.["custom:organizationId"],
          }

          const res = await API.post(CORE, "/chargebee/pricing_page", {
            headers: headers,
            body: body,
          })

          return res
        },
      })
    }
  }, [user])

  const openCustomerPortal = useCallback(
    async e => {
      e.preventDefault()
      if (!window.Chargebee) {
        console.error("Chargebee.js no está cargado")
        return
      }
      window.cbInstance =
        window.cbInstance ||
        window.Chargebee.init({ site: process.env.REACT_APP_CHARGEBEE_SITE })
      const cb = window.cbInstance
      cb.setPortalSession(() =>
        createChargebeePortal().then(res => {
          const session = extractChargebeePortalSession(res)
          if (!session) {
            return Promise.reject(new Error("Invalid Chargebee portal session"))
          }
          return session
        }),
      )
      const portal = cb.createChargebeePortal()
      portal.open({
        close: () => getCustomerInfo(),
      })
    },
    [createChargebeePortal, getCustomerInfo],
  )

  return (
    <Grid>
      <Grid item container justifyContent="flex-end">
        <LinkAsOutlinedButton href="#" onClick={openCustomerPortal}>
          {i18n.t("manageAccount")}
        </LinkAsOutlinedButton>
      </Grid>
      <Grid item>
        <div
          id="pricify-hosted-pricing-page"
          data-pricify-integrationtype="api"
        ></div>
      </Grid>
    </Grid>
  )
}

export default PricingPage
